module.exports = __webpack_public_path__ + "static/media/iar_vehicle_ems_hover.bf9007a6.svg";